import { render, staticRenderFns } from "./CardConfig.vue?vue&type=template&id=055c744c&"
import script from "./CardConfig.vue?vue&type=script&lang=js&"
export * from "./CardConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports